import { render } from "./About.vue?vue&type=template&id=5ac081ad&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=5ac081ad&lang=less&scoped=true"

import exportComponent from "/Users/apple/Documents/优学在线PC/yxzxpc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ac081ad"]])

export default __exports__